<template>
    <el-dialog title="项目选择"
               width="60%"
               top="6vh"
               append-to-body
               :visible.sync="isVisible">
        <el-row type="flex" justify="space-between" style="flex-wrap: wrap;" v-if="projectList.length">
            <el-card class="card" v-for="(item, index) in projectList" :key="item.Id"
                     :class="{'is-last-child': (projectList.length % 3 === 2) && index === projectList.length - 1}"
                     :body-style="{height: '100%', boxSizing: 'border-box'}"
                     @mouseenter.native.stop="handleMouseEnter(item.Id)"
                     @mouseleave.native.stop="handleMouseLeave(item.Id)">
                <transition name="fade-top">
                    <div v-show="!projectHoverStatus[item.Id]" class="card-desc--container">
                        <header class="header">{{ item.Name }}</header>
                        <div class="list-item-status">{{QUESTION_STATUS[item.State]}}</div>
                        <div class="card-desc--count">共{{ item.DetailQty }}题</div>
                    </div>
                </transition>
                <transition name="fade-top">
                    <el-row
                        v-show="projectHoverStatus[item.Id]"
                        type="flex"
                        class="color-primary--text"
                        justify="center"
                        align="middle"
                        style="height: 100%">
                        <div
                            @click.stop="handleCopy(item)"
                            style="margin-right: 16px">复制
                        </div>
                        |
                        <div style="margin-left: 16px"
                             @click.stop="handlePreview(item)">预览</div>
                    </el-row>
                </transition>
            </el-card>
        </el-row>
        <el-empty description="暂无项目可复制" v-else/>
        <pagination :p-size.sync="pageSize"
                    :page-sizes="[12, 24, 36, 48]"
                    @change="getQuestionList"
                    :total="total" :page-no.sync="pageIndex"/>
    </el-dialog>
</template>

<script>
import { getQuestionList, addQuestion, getQuestionnaireDetail } from "@/api/new-question-iteration/question-library";
import Pagination from "@/components/Pagination";
import { QUESTION_STATUS } from "@/utils/question-config";

export default {
    name: "copy",
    components: { Pagination },
    data() {
        return {
            isVisible: false,
            projectHoverStatus: {}, // 记录各项目的hover状态
            projectList: [],
            pageIndex: 1,
            pageSize: 12,
            total: 12,
            QUESTION_STATUS
        }
    },
    methods: {
        open() {
            this.isVisible = true
            this.getQuestionList()
        },
        close() {
            this.isVisible = false
        },
        // 鼠标移入
        handleMouseEnter(id) {
            this.$set(this.projectHoverStatus, id, true)
        },
        // 鼠标移出
        handleMouseLeave(id) {
            this.$set(this.projectHoverStatus, id, false)
        },
        // 获取问卷列表
        getQuestionList() {
            const {
                pageSize,
                pageIndex
            } = this
            getQuestionList({
                pageSize,
                pageIndex
            }).then(res => {
                this.projectList = res.data
                this.total = res.count
            })
        },
        // 处理复制
        async handleCopy(item) {
            const res = await getQuestionnaireDetail(item.Id)
            const { Name, Title, QuestionnaireDetaillist, Tag } = res
            const resp = await addQuestion({
                Name,
                Title,
                Details: QuestionnaireDetaillist.map(list => Object.assign(list, { Id: undefined, QuestionnaireId: undefined })),
                Tag
            })
            this.$message.success("复制成功")
            this.$router.push({
                name: "CreateEmpty",
                query: {
                    Qid: resp,
                    isPublish: false
                }
            })
        },
        // 预览
        handlePreview (item) {
            this.$router.push({
                name: "ManageViewQuestion",
                query: {
                    Qid: item.Id,
                    isPublish: parseInt(item.State) !== 0
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../sidebar-psq/index.less";
.header {
    word-break: break-all;
}

.card {
    width: 32%;
    height: 201px;
    cursor: pointer;
    margin-bottom: 2%;
    font-weight: 500;
    font-size: 16px;

    &.is-last-child {
        margin-left: 2%;
        margin-right: auto;
    }
}

.card-desc--container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    height: 100%;
}

.card-desc--count {
    font-size: 14px;
    color: #909399;
}
.list-item-status {
    color: @--color-warning;
    font-size: 14px;
}
</style>
